import "./index.less";
import {  useEffect, useState } from "react";
import { Skeleton } from "antd";
import { GlobalCable } from "@/commons/interface/maint/lib-device/global-cable";
import { getGlobalCableDetail } from "@/api/maint/lib/lib-cable";

interface IProps {
    cableId: number
    needRender: boolean
}

export default function LibCablePanel(props: IProps) {
    const [globalCable, setGlobalCable] = useState<GlobalCable>(null); // 传感器
    const [loading, setLoading] = useState<boolean>(false); // loading

    // 初始化
    useEffect(() => {
        if (!props?.cableId) return;
        setLoading(true)

        getGlobalCableDetail(+props?.cableId).then(res => {
            let data: GlobalCable = res.data || null;
            setGlobalCable(data);
        }).finally(() => {
            setLoading(false);
        })
    }, [props?.cableId, props?.needRender])

    return (
        <div className="lib-cable-container">
            <Skeleton loading={loading}>
                <div className="title">
                    {'数据线缆'}
                </div>
                <div className="main">

                    <div className="item">
                        <div className="item-name">型号</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalCable?.marking || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">厂商</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalCable?.manufacturer || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">规格</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalCable?.specification || ''}
                            </div>
                        </div>
                    </div>
                </div>
            </Skeleton>
        </div>
    )
}